import React from 'react'
import Box from '@ui/Box'
import { closeHeaderPromoBanner, useGetProfile, useGetPromoInfo } from '@api/users'
import IconButton from '@ui/IconButton'
import { MdInfoOutline } from 'react-icons/md'
import { Color } from '@interfaces/designSystem'

const PromoHeaderBanner = () => {
  const { data, refetch } = useGetProfile()
  const { data: promoInfo } = useGetPromoInfo()
  const [loading, setLoading] = React.useState(false)

  if (promoInfo?.type && data && !data.promoHeaderBannerClosed) {
    let text
    switch (promoInfo.type) {
      case 'free': {
        text =
          'Using your promo code you could use Enhanci for free. Great to see you aboard!'
        break
      }

      case 'free2M': {
        text =
          'Using your promo code you could use Enhanci for free for 2 months. Great to see you aboard!'
        break
      }

      case 'free3M': {
        text =
          'Using your promo code you could use Enhanci for free for 3 months. Great to see you aboard!'
        break
      }
    }

    if (!text) {
      return null
    }
    return (
      <Box
        fontSize={16}
        bg={Color.Blue_30}
        color={Color.Blue_95}
        p="8px 0"
        textAlign="center"
      >
        <Box style={{ verticalAlign: 'middle' }} display="inline" mr={8}>
          🚀
        </Box>
        {text}
        <IconButton
          containerProps={{ display: 'inline-block', ml: 12 }}
          type="default"
          loading={loading}
          onClick={async () => {
            setLoading(true)

            try {
              await closeHeaderPromoBanner()
              refetch()
            } finally {
              setLoading(false)
            }
          }}
        >
          Got it
        </IconButton>
      </Box>
    )
  }

  return null
}

export default PromoHeaderBanner
